(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    (function() {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var RESUME_DELAY = 1700;

    document.querySelectorAll('[data-cl-track]').forEach(function(track) {
      var loop = track.closest('.carousel-loop');
      if (!loop) return;
      var dots = loop.querySelectorAll('[data-cl-dot]');
      var originals = Array.prototype.slice.call(track.children);
      var ORIGINAL_COUNT = originals.length;
      if (ORIGINAL_COUNT < 2) return;

      // "Seconds per slide" setting → constant flow speed.
      var secondsPerSlide = parseFloat(getComputedStyle(loop).getPropertyValue('--carousel-loop-interval')) || 6;

      var current = 0;
      var setWidth = 0;         // width of one full set of original slides
      var speedPxPerMs = 0;
      var flowFrame = null;
      var lastTime = null;
      var resumeTimer = null;
      var position = 0;         // float accumulator — scrollLeft reads are
                                // pixel-quantized and would swallow sub-pixel steps

      // A seamless loop needs the content to repeat: clone the original set
      // until the track can scroll one full set with the viewport still covered.
      function addClones() {
        var guard = 0;
        while (track.scrollWidth < track.clientWidth * 2 + setWidth && guard < 6) {
          originals.forEach(function(slide) {
            var clone = slide.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-cl-clone', '');
            clone.querySelectorAll('a, button, input, [tabindex]').forEach(function(el) {
              el.tabIndex = -1;
            });
            track.appendChild(clone);
          });
          guard++;
        }
      }

      function measure() {
        var firstClone = track.querySelector('[data-cl-clone]');
        if (firstClone) {
          setWidth = firstClone.offsetLeft - originals[0].offsetLeft;
        } else {
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var last = originals[ORIGINAL_COUNT - 1];
          setWidth = last.offsetLeft + last.offsetWidth - originals[0].offsetLeft + gap;
        }
        speedPxPerMs = setWidth / ORIGINAL_COUNT / (Math.max(1, secondsPerSlide) * 1000);
      }

      function updateDots() {
        if (!dots.length) return;
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === current); });
      }

      function syncDotsToScroll() {
        if (!dots.length || !setWidth) return;
        var center = (track.scrollLeft % setWidth) + track.clientWidth / 2;
        var closest = current;
        var minDist = Infinity;
        originals.forEach(function(slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          // Compare within one set; account for wrap-around distance.
          var dist = Math.min(
            Math.abs(slideCenter - center),
            Math.abs(slideCenter + setWidth - center),
            Math.abs(slideCenter - setWidth - center)
          );
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        if (closest !== current) {
          current = closest;
          updateDots();
        }
      }

      // ── Continuous flow (marquee-style, constant velocity) ──
      function flowStep(now) {
        if (lastTime !== null) {
          var dt = Math.min(now - lastTime, 100);
          position += speedPxPerMs * dt;
          if (setWidth > 0 && position >= setWidth) position -= setWidth;
          track.scrollLeft = position;
          syncDotsToScroll();
        }
        lastTime = now;
        flowFrame = requestAnimationFrame(flowStep);
      }

      function startFlow() {
        if (prefersReduced || flowFrame) return;
        // Mandatory snap would fight the continuous motion.
        track.style.scrollSnapType = 'none';
        position = track.scrollLeft;
        lastTime = null;
        flowFrame = requestAnimationFrame(flowStep);
      }

      function stopFlow(restoreSnap) {
        if (flowFrame) { cancelAnimationFrame(flowFrame); flowFrame = null; }
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
        if (restoreSnap) track.style.scrollSnapType = '';
      }

      function pauseThenResume() {
        stopFlow(false);
        resumeTimer = setTimeout(startFlow, RESUME_DELAY);
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(dot.dataset.clDot, 10);
          var slide = originals[index];
          if (slide) {
            stopFlow(false);
            var target = slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
            // Center the slide's clone when the true target would clamp at 0,
            // so the dot sync (wrap-aware) agrees with the clicked index.
            if (target < 0 && setWidth > 0) target += setWidth;
            track.scrollLeft = Math.max(0, target);
            current = index;
            updateDots();
            resumeTimer = setTimeout(startFlow, RESUME_DELAY);
          }
        });
      });

      track.addEventListener('pointerdown', function() { stopFlow(false); });
      track.addEventListener('pointerup', pauseThenResume);
      // Touch swipes on a scrollable track end in pointercancel, not pointerup.
      track.addEventListener('pointercancel', pauseThenResume);
      track.addEventListener('mouseenter', function() { stopFlow(false); });
      track.addEventListener('mouseleave', startFlow);
      track.addEventListener('focusin', function() { stopFlow(false); });
      track.addEventListener('focusout', startFlow);
      track.addEventListener('scroll', function() {
        if (!flowFrame) syncDotsToScroll();
      });

      var resizeTimer = null;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          measure();
          addClones();
        }, 150);
      });

      requestAnimationFrame(function() {
        measure();
        addClones();
        measure();
        updateDots();

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) startFlow();
              else stopFlow(false);
            });
          }, { threshold: 0.15 }).observe(loop);
        } else {
          startFlow();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Exclusive accordions: only one row open at a time. Accordion blocks
  // sharing a section form ONE group (data-accordion-exclusive carries the
  // section id), so sibling accordion blocks coordinate too. Delegated on
  // document (capture — 'toggle' does not bubble) so it keeps working after
  // theme-editor section re-renders replace the DOM.
  document.addEventListener('toggle', function(event) {
    var d = event.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var acc = d.closest('[data-accordion-exclusive]');
    if (!acc) return;
    var selector = '[data-accordion-exclusive="' + acc.dataset.accordionExclusive + '"] details';
    document.querySelectorAll(selector).forEach(function(other) {
      // Never close an ancestor/descendant of the toggled row (nested details).
      if (other !== d && other.open && !other.contains(d) && !d.contains(other)) {
        other.open = false;
      }
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nosu-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initNosuAtc(root) {
    var bid       = root.id.replace('nosu-atc-', '');
    var vidInput  = document.getElementById('nosu-atc-vid-' + bid);
    var planInput = document.getElementById('nosu-atc-plan-' + bid);
    var atcPrice  = root.querySelector('[data-atc-price]');
    var rows      = Array.prototype.slice.call(root.querySelectorAll('[data-atc-row]'));
    var otpRow    = root.querySelector('[data-atc-row="otp"]');
    var subRow    = root.querySelector('[data-atc-row="sub"]');
    var subDesc        = root.querySelector('[data-sub-desc]');
    var deliveryDescEl = root.querySelector('[data-delivery-desc]');
    var qtyInput       = root.querySelector('[data-qty-input]');
    var qtyDec         = root.querySelector('[data-qty-dec]');
    var qtyInc         = root.querySelector('[data-qty-inc]');
    var form           = root.querySelector('form');
    var atcButton      = root.querySelector('[data-atc-btn]');
    var atcStatus      = root.querySelector('[data-atc-status]');
    // ─── Helpers ────────────────────────────────────────────────

    // Multiply a money-formatted string ("$9.99 / total") by an integer.
    // Preserves the surrounding format (currency symbol, locale separators).
    function multiplyMoney(template, multiplier) {
      if (!template || multiplier === 1) return template;
      return template.replace(/\d[\d,.]*/, function (numStr) {
        var decMatch = numStr.match(/[.,]\d{1,2}$/);
        var decimals = 0, decimalSep = '.', thousandSep = ',';
        var integerStr = numStr, fractionStr = '';

        if (decMatch) {
          decimalSep  = decMatch[0].charAt(0);
          thousandSep = decimalSep === '.' ? ',' : '.';
          decimals    = decMatch[0].length - 1;
          integerStr  = numStr.slice(0, -decMatch[0].length);
          fractionStr = decMatch[0].slice(1);
        }

        var cleanInt = integerStr.split(thousandSep).join('');
        var asNumber = parseFloat(cleanInt + (fractionStr ? '.' + fractionStr : ''));
        var total    = asNumber * multiplier;

        var fixed = total.toFixed(decimals);
        var parts = fixed.split('.');
        parts[0]  = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
        return decimals > 0 ? parts[0] + decimalSep + parts[1] : parts[0];
      });
    }

    var unitAtcFmt     = '';
    var unitPpdFmt     = '';
    var unitTotalFmt   = '';
    var unitCompareFmt = '';
    var activeFmtRow   = null;

    function getQty() {
      if (!qtyInput) return 1;
      var v = parseInt(qtyInput.value, 10);
      return (isNaN(v) || v < 1) ? 1 : v;
    }

    function refreshPriceForQty() {
      var q = getQty();
      if (atcPrice) {
        atcPrice.textContent = multiplyMoney(unitAtcFmt, q);
        if (unitCompareFmt) {
          atcPrice.setAttribute('data-compare-fmt', multiplyMoney(unitCompareFmt, q));
        } else {
          atcPrice.removeAttribute('data-compare-fmt');
        }
      }
      if (activeFmtRow) {
        var summary = activeFmtRow.querySelector('[data-summary]');
        if (summary) {
          var ppd     = summary.querySelector('[data-ppd]');
          var total   = summary.querySelector('[data-total]');
          var compare = summary.querySelector('[data-compare]');
          if (ppd)   ppd.textContent   = unitPpdFmt || '';
          if (total) total.textContent = multiplyMoney(unitTotalFmt, q);
          if (compare) {
            if (unitCompareFmt) {
              compare.textContent = multiplyMoney(unitCompareFmt, q);
              compare.style.display = '';
            } else {
              compare.textContent = '';
              compare.style.display = 'none';
            }
          }
          summary.classList.remove('nosu-atc__summary--hidden');
        }
      }
    }

    function setUnitPrices(row, atcFmt, ppdFmt, totalFmt, compareFmt) {
      unitAtcFmt     = atcFmt || '';
      unitPpdFmt     = ppdFmt || '';
      unitTotalFmt   = totalFmt || '';
      unitCompareFmt = compareFmt || '';
      activeFmtRow   = row;
      refreshPriceForQty();
    }

    function selectTiles(container, chosen) {
      Array.prototype.forEach.call(
        container.querySelectorAll('[data-variant-tile], [data-plan-tile]'),
        function (t) {
          var on = t === chosen;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      );
    }

    // ─── Row callout ("Save up to X%") ────────────────────────────
    // Keep this summary on collapsed rows only. The expanded row already
    // communicates its offer inside the option tiles and price summary.

    function setActiveCallout(row) {
      var callout = row && row.querySelector('[data-callout]');
      if (!callout) return;
      if (!callout.dataset.defaultText) callout.dataset.defaultText = callout.textContent.trim();
      callout.style.display = 'none';
    }

    // ─── Activate a row (expand it, collapse the other) ─────────

    function activateRow(target) {
      rows.forEach(function (row) {
        var on = row === target;
        var hd = row.querySelector('[data-row-hd]');

        row.classList.toggle('is-active', on);
        if (hd) hd.setAttribute('aria-expanded', on ? 'true' : 'false');

        var callout = row.querySelector('[data-callout]');
        var summary = row.querySelector('[data-summary]');
        if (callout) {
          if (!callout.dataset.defaultText) callout.dataset.defaultText = callout.textContent.trim();
          if (on) {
            // Expanded rows show the offer in their option tiles instead.
            callout.style.display = 'none';
          } else {
            callout.textContent = callout.dataset.defaultText;
            callout.style.display = '';
          }
        }
        if (summary) summary.classList.toggle('nosu-atc__summary--hidden', !on);
      });
      root.dataset.activeRow = target.dataset.atcRow;

      if (target === subRow) {
        setQty(1);
      }
    }

    // ─── Quantity stepper ───────────────────────────────────────

    function updateQtyButtons() {
      if (!qtyInput || !qtyDec) return;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyDec.disabled = v <= 1;
    }

    function setQty(v) {
      v = parseInt(v, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (qtyInput) qtyInput.value = String(v);
      updateQtyButtons();
      refreshPriceForQty();
      document.dispatchEvent(new CustomEvent('nosu-atc:qty-change', { detail: { qty: v } }));
    }

    if (qtyDec && qtyInput) {
      qtyDec.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }
    if (qtyInc && qtyInput) {
      qtyInc.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + 1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQty(qtyInput.value);
      });
    }

    // External (e.g. floating ATC) can push qty changes here.
    root.addEventListener('nosu-atc:set-qty', function (e) {
      setQty(e.detail && e.detail.qty);
    });

    // ─── AJAX add to cart ────────────────────────────────────────
    // Request the cart drawer's sections with the add, then publish the same
    // event as the theme's native product form. The existing drawer owns its
    // rendering and open animation; this block only supplies the cart update.

    function cartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
        var id = component.getAttribute('data-section-id');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    }

    function setSubmitting(isSubmitting) {
      if (!atcButton) return;
      atcButton.disabled = isSubmitting;
      atcButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }

    function setCartDrawerBusy(isBusy) {
      var drawer = document.querySelector('cart-drawer-component');
      var items = drawer && drawer.querySelector('cart-items-component');
      if (items) {
        if (isBusy) items.setAttribute('aria-busy', 'true');
        else items.removeAttribute('aria-busy');
      }
      return drawer;
    }

    function openCartDrawer() {
      var drawer = setCartDrawerBusy(true);
      if (!drawer) return;
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else if (window.customElements) {
        customElements.whenDefined('cart-drawer-component').then(function () {
          if (typeof drawer.open === 'function') drawer.open();
        });
      }
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (atcButton && atcButton.getAttribute('aria-busy') === 'true') return;

        setSubmitting(true);
        if (atcStatus) atcStatus.textContent = '';

        var formData = new FormData(form);
        var sectionIds = cartSectionIds();
        if (sectionIds.length) formData.set('sections', sectionIds.join(','));
        openCartDrawer();

        fetch(form.dataset.ajaxAction || form.action, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response.status) {
              var message = response.description || response.message || '';
              if (atcStatus) atcStatus.textContent = message;
              root.dispatchEvent(new CustomEvent('cart:error', {
                bubbles: true,
                detail: {
                  sourceId: form.id,
                  data: {
                    message: response.message,
                    description: response.description,
                    errors: response.errors
                  }
                }
              }));
              return;
            }

            var variantId = String(formData.get('id') || '');
            root.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: form.id,
                data: {
                  source: 'nosu-atc',
                  itemCount: Number(formData.get('quantity')) || 1,
                  productId: root.dataset.productId || '',
                  variantId: variantId,
                  sections: response.sections || {}
                }
              }
            }));
          })
          .catch(function (error) {
            console.error('[nosu-atc] Add to cart failed:', error);
          })
          .finally(function () {
            setSubmitting(false);
            setCartDrawerBusy(false);
          });
      });
    }

    // ─── OTP: apply a variant tile ───────────────────────────────

    function applyVariantTile(tile) {
      if (!tile || !otpRow) return;
      selectTiles(otpRow, tile);

      if (vidInput)  vidInput.value       = tile.dataset.variantId;
      if (planInput) { planInput.disabled = true; planInput.value = ''; }

      setUnitPrices(otpRow, tile.dataset.priceFmt, tile.dataset.ppdFmt, tile.dataset.totalFmt, tile.dataset.compareFmt);
      if (otpRow.classList.contains('is-active')) setActiveCallout(otpRow, tile);
    }

    // ─── Sub: apply a plan tile ──────────────────────────────────

    // Each plan tile carries its own variant — one selling plan per pack.
    function applyPlanTile(tile) {
      if (!tile || !subRow) return;
      selectTiles(subRow, tile);

      if (vidInput)  vidInput.value        = tile.dataset.variantId;
      if (planInput) { planInput.disabled  = false; planInput.value = tile.dataset.planId; }

      setUnitPrices(subRow, tile.dataset.priceFmt, tile.dataset.ppdFmt, tile.dataset.totalFmt, tile.dataset.compareFmt);
      if (subRow.classList.contains('is-active')) setActiveCallout(subRow, tile);
      if (subDesc) subDesc.textContent = tile.dataset.planName || '';
      if (deliveryDescEl) deliveryDescEl.textContent = tile.dataset.planOption || '';
    }

    // ─── Row header clicks ───────────────────────────────────────

    // Carry the chosen pack across rows: pick the tile for the variant that is
    // currently in the form, falling back to whatever the row had selected.
    function tileForCurrentVariant(row, sel) {
      var vid = vidInput && vidInput.value;
      return (vid && row.querySelector(sel + '[data-variant-id="' + vid + '"]:not([disabled])'))
          || row.querySelector(sel + '.is-selected')
          || row.querySelector(sel);
    }

    rows.forEach(function (row) {
      var hd = row.querySelector('[data-row-hd]');
      if (!hd) return;
      hd.addEventListener('click', function () {
        if (row.classList.contains('is-active')) return;
        activateRow(row);

        if (row === otpRow) {
          applyVariantTile(tileForCurrentVariant(otpRow, '[data-variant-tile]'));
        } else if (row === subRow) {
          applyPlanTile(tileForCurrentVariant(subRow, '[data-plan-tile]'));
        }
      });
    });

    // ─── Tile clicks ─────────────────────────────────────────────

    if (otpRow) {
      otpRow.querySelectorAll('[data-variant-tile]').forEach(function (tile) {
        tile.addEventListener('click', function () { applyVariantTile(tile); });
      });
    }

    if (subRow) {
      subRow.querySelectorAll('[data-plan-tile]').forEach(function (tile) {
        tile.addEventListener('click', function () { applyPlanTile(tile); });
      });
    }

    // ─── Init: set form state for default OTP selection ─────────
    var defaultTile = otpRow && (
      otpRow.querySelector('[data-variant-tile].is-selected') ||
      otpRow.querySelector('[data-variant-tile]')
    );
    applyVariantTile(defaultTile);
    updateQtyButtons();
  }

  document.querySelectorAll('[data-nosu-atc]').forEach(initNosuAtc);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nosu-explainer-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nosu-explainer-tabs')) {
    customElements.define(
      'nosu-explainer-tabs',
      class NosuExplainerTabs extends HTMLElement {
        connectedCallback() {
          this.componentController?.abort();
          this.componentController = new AbortController();

          const signal = this.componentController.signal;
          this.tabsContainer = this.querySelector('[data-nosu-tabs]');
          this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

          this.addEventListener('click', this.handleClick, { signal });
          this.addEventListener('focusin', this.handleFocusIn, { signal });
          this.addEventListener('keydown', this.handleKeyDown, { signal });
          this.addEventListener('pointerleave', this.handlePointerLeave, { signal });
          document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });

          if (this.tabsContainer) {
            this.observer = new MutationObserver(() => this.scheduleRefresh());
            this.observer.observe(this.tabsContainer, { childList: true, subtree: true });
          }

          this.refresh();
        }

        disconnectedCallback() {
          this.componentController?.abort();
          this.tabController?.abort();
          this.observer?.disconnect();
        }

        scheduleRefresh() {
          if (this.refreshQueued) return;

          this.refreshQueued = true;
          queueMicrotask(() => {
            this.refreshQueued = false;
            if (this.isConnected) this.refresh();
          });
        }

        refresh() {
          const previouslyLockedId = this.tabs?.[this.lockedIndex]?.id;

          this.tabController?.abort();
          this.tabController = new AbortController();
          const signal = this.tabController.signal;

          this.tabItems = Array.from(this.querySelectorAll('[data-nosu-tab-item]'));
          this.tabs = this.tabItems
            .map((tabItem) => tabItem.querySelector('[data-nosu-tab]'))
            .filter((tab) => tab instanceof HTMLButtonElement);
          this.panels = this.tabItems
            .map((tabItem) => tabItem.querySelector('[data-nosu-panel]'))
            .filter((panel) => panel instanceof HTMLElement);

          this.classList.toggle('is-empty', this.tabs.length === 0);

          if (!this.tabs.length) {
            this.classList.add('is-ready');
            return;
          }

          this.tabs.forEach((tab) => {
            tab.addEventListener('pointerenter', this.handlePointerEnter, { signal });
          });

          const preservedIndex = previouslyLockedId
            ? this.tabs.findIndex((tab) => tab.id === previouslyLockedId)
            : -1;

          this.activate(preservedIndex >= 0 ? preservedIndex : 0, {
            lock: true,
            instant: true,
          });
          this.classList.add('is-ready');
        }

        activate(index, options = {}) {
          if (index < 0 || index >= this.tabs.length) return;

          const { lock = false, focus = false, instant = false } = options;

          if (lock) this.lockedIndex = index;
          if (instant) this.classList.add('is-refreshing');

          this.tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === index;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-expanded', String(isActive));
            tab.setAttribute('aria-pressed', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel, panelIndex) => {
            const isActive = panelIndex === index;
            panel.classList.toggle('is-active', isActive);
            panel.setAttribute('aria-hidden', String(!isActive));
            panel.inert = !isActive;
          });

          if (focus) this.tabs[index].focus();

          if (instant) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => this.classList.remove('is-refreshing'));
            });
          }
        }

        indexOfTab(tab) {
          return this.tabs.indexOf(tab);
        }

        handleClick = (event) => {
          if (!(event.target instanceof Element)) return;

          const tab = event.target.closest('[data-nosu-tab]');
          if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

          this.activate(this.indexOfTab(tab), { lock: true });
        };

        handleFocusIn = (event) => {
          if (!(event.target instanceof Element)) return;

          const tab = event.target.closest('[data-nosu-tab]');
          if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

          this.activate(this.indexOfTab(tab), { lock: true });
        };

        handlePointerEnter = (event) => {
          if (!this.hoverQuery.matches) return;

          const tab = event.currentTarget;
          if (!(tab instanceof HTMLButtonElement)) return;

          this.activate(this.indexOfTab(tab));
        };

        handlePointerLeave = () => {
          if (!this.hoverQuery.matches || this.lockedIndex === undefined) return;

          this.activate(this.lockedIndex);
        };

        handleKeyDown = (event) => {
          if (!(event.target instanceof Element)) return;

          const tab = event.target.closest('[data-nosu-tab]');
          if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

          const currentIndex = this.indexOfTab(tab);
          let nextIndex;

          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              nextIndex = (currentIndex + 1) % this.tabs.length;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
              break;
            case 'Home':
              nextIndex = 0;
              break;
            case 'End':
              nextIndex = this.tabs.length - 1;
              break;
            default:
              return;
          }

          event.preventDefault();
          this.activate(nextIndex, { lock: true, focus: true });
        };

        handleBlockSelect = (event) => {
          if (!(event.target instanceof Element)) return;

          const tabItem = event.target.closest('[data-nosu-tab-item]');
          if (!tabItem || !this.contains(tabItem)) return;

          const tabIndex = this.tabItems.indexOf(tabItem);
          if (tabIndex >= 0) this.activate(tabIndex, { lock: true, instant: true });
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nosu-payment-safe"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.nosu-paysafe__pill').forEach(function (pill) {
    var modalId = pill.getAttribute('aria-controls');
    var modal   = document.getElementById(modalId);
    if (!modal) return;

    function openModal() {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-paysafe-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      pill.focus();
    }

    pill.addEventListener('click', openModal);

    modal.querySelectorAll('[data-paysafe-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    // Close on backdrop click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nosu-urgency-countdown-new"] && !Shopify.designMode) return;
  try {
    (function () {

  'use strict';

  /*
   * Warehouse operational timezone.
   *
   * Europe/Amsterdam automatically handles:
   * CET in winter
   * CEST in summer
   */
  var TIME_ZONE = 'Europe/Amsterdam';


  /*
   * Convert ISO country code such as "NL"
   * into the corresponding flag emoji.
   */
  function countryCodeToEmoji(code) {

    if (!code || code.length !== 2) {
      return '';
    }

    return code
      .toUpperCase()
      .replace(/./g, function(character) {

        return String.fromCodePoint(
          127397 + character.charCodeAt()
        );

      });

  }


  /*
   * Current time specifically in Europe/Amsterdam.
   *
   * en-GB here is only used to extract numeric calendar
   * values. It does NOT control the displayed language.
   */
  function getAmsterdamParts() {

    var formatter =
      new Intl.DateTimeFormat(
        'en-GB',
        {
          timeZone: TIME_ZONE,

          year: 'numeric',
          month: 'numeric',
          day: 'numeric',

          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',

          hourCycle: 'h23'
        }
      );

    var parts =
      formatter.formatToParts(new Date());

    var result = {};

    parts.forEach(function(part) {

      if (part.type !== 'literal') {
        result[part.type] =
          parseInt(part.value, 10);
      }

    });

    return result;
  }


  /*
   * Create a safe calendar-date object.
   *
   * Noon UTC prevents accidental date rollover
   * when later formatting the date.
   */
  function calendarDate(year, month, day) {

    return new Date(
      Date.UTC(
        year,
        month - 1,
        day,
        12,
        0,
        0
      )
    );

  }


  function addDays(date, amount) {

    var copy = new Date(date);

    copy.setUTCDate(
      copy.getUTCDate() + amount
    );

    return copy;

  }


  /*
   * Localize the visible shipping date according to
   * Shopify's currently active storefront language.
   *
   * Examples:
   *
   * EN → Wed, 30 Sep
   * NL → wo 30 sep
   */
  function formatShipDate(date, locale) {

    var intlLocale;

    if (locale === 'nl') {
      intlLocale = 'nl-NL';
    }
    else if (locale === 'en') {
      intlLocale = 'en-GB';
    }
    else {
      /*
       * Other Shopify locale codes such as
       * de, fr, es, it etc. can normally be
       * passed straight to Intl.
       */
      intlLocale = locale || 'en-GB';
    }

    var formatted =
      new Intl.DateTimeFormat(
        intlLocale,
        {
          timeZone: TIME_ZONE,
          weekday: 'short',
          day: 'numeric',
          month: 'short'
        }
      ).format(date);


    /*
     * Preserve the existing English style:
     *
     * Wed 30 Sep
     * →
     * Wed, 30 Sep
     *
     * Do NOT add this comma to Dutch.
     */
    if (
      intlLocale === 'en-GB' &&
      !formatted.match(/^[A-Za-z]{3},/)
    ) {

      formatted =
        formatted.replace(
          /^([A-Za-z]{3})\s/,
          '$1, '
        );

    }

    return formatted;
  }


  function pad(number) {

    return String(number).padStart(
      2,
      '0'
    );

  }


  document
    .querySelectorAll(
      '.nosu-shipping-countdown'
    )
    .forEach(function(el) {

      var timerEl =
        el.querySelector(
          '.nosu-shipping-countdown__timer'
        );

      var shipDateEl =
        el.querySelector(
          '.nosu-shipping-countdown__ship-date'
        );

      var flagEl =
        el.querySelector(
          '.nosu-shipping-countdown__flag'
        );

      var locale =
        el.dataset.locale || 'en';

      var shipTemplate =
        el.dataset.shipTemplate ||
        'Ships <strong>__DATE__</strong>';


      /*
       * Protect against accidentally deleting the
       * __DATE__ placeholder in the Theme Editor.
       */
      if (
        shipTemplate.indexOf('__DATE__') === -1
      ) {

        shipTemplate =
          shipTemplate +
          ' <strong>__DATE__</strong>';

      }


      var cutoffHour =
        parseInt(
          el.dataset.cutoffHour || '22',
          10
        );

      var cutoffMinute =
        parseInt(
          el.dataset.cutoffMinute || '0',
          10
        );


      /*
       * Automatic visitor-country flag.
       */
      if (flagEl) {

        flagEl.textContent =
          countryCodeToEmoji(
            el.dataset.countryCode
          );

      }


      function update() {

        var now =
          getAmsterdamParts();


        /*
         * Current Amsterdam calendar date.
         */
        var today =
          calendarDate(
            now.year,
            now.month,
            now.day
          );


        /*
         * Has warehouse cutoff passed?
         */
        var currentSeconds =
          (
            now.hour * 3600
          ) +
          (
            now.minute * 60
          ) +
          now.second;


        var cutoffSeconds =
          (
            cutoffHour * 3600
          ) +
          (
            cutoffMinute * 60
          );


        var cutoffPassed =
          currentSeconds >= cutoffSeconds;


        /*
         * SHIPPING DATE
         *
         * Before cutoff:
         * today
         *
         * After cutoff:
         * tomorrow
         */
        var shippingDate =
          cutoffPassed
            ? addDays(today, 1)
            : today;


        if (shipDateEl) {

          var localizedDate =
            formatShipDate(
              shippingDate,
              locale
            );

          shipDateEl.innerHTML =
            shipTemplate.replace(
              '__DATE__',
              localizedDate
            );

        }


        /*
         * COUNTDOWN
         *
         * Before cutoff:
         * remaining time until cutoff today
         *
         * After cutoff:
         * remaining time until cutoff tomorrow
         */
        if (timerEl) {

          var remainingSeconds;

          if (!cutoffPassed) {

            remainingSeconds =
              cutoffSeconds -
              currentSeconds;

          }
          else {

            remainingSeconds =
              (
                24 * 3600
              ) -
              currentSeconds +
              cutoffSeconds;

          }


          var hours =
            Math.floor(
              remainingSeconds / 3600
            );


          var minutes =
            Math.floor(
              (
                remainingSeconds % 3600
              ) / 60
            );


          var seconds =
            remainingSeconds % 60;


          timerEl.textContent =
            pad(hours) +
            ':' +
            pad(minutes) +
            ':' +
            pad(seconds);

        }

      }


      update();

      setInterval(
        update,
        1000
      );

    });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nosu-urgency-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.nosu-urgency').forEach(function (el) {
    var timerEl   = el.querySelector('.nosu-urgency__timer');
    var textEl    = el.querySelector('.nosu-urgency__text');
    var expiredEl = el.querySelector('.nosu-urgency__expired');
    var dotEl     = el.querySelector('.nosu-urgency__dot');

    if (!timerEl) return;

    var cutoffHour = parseInt(el.dataset.cutoffHour || '17', 10);
    var cutoffMin  = parseInt(el.dataset.cutoffMinute || '0', 10);

    function getTargetMs() {
      var now    = new Date();
      var target = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        cutoffHour,
        cutoffMin,
        0,
        0
      );
      // If cutoff already passed today, aim for tomorrow
      if (target <= now) {
        target.setDate(target.getDate() + 1);
      }
      return target.getTime();
    }

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function showExpired() {
      if (textEl)    textEl.hidden    = true;
      if (dotEl)     dotEl.hidden     = true;
      if (expiredEl) expiredEl.hidden = false;
    }

    var targetMs = getTargetMs();
    var interval;

    function tick() {
      var remaining = targetMs - Date.now();

      if (remaining <= 0) {
        // Reset target to next day and keep counting
        targetMs = getTargetMs();
        remaining = targetMs - Date.now();
      }

      var totalSec = Math.floor(remaining / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;

      timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    tick();
    interval = setInterval(tick, 1000);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
